"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
require("../../scss/_sub-navigation.scss");
/**
 * @component SubNavigation
 * @example
 * return (
 *   <SubNavigation
 *      subNav={subNav}
 *      subNavItemsToIgnore={subNavItemsToIgnore}
 *   />
 * )
 *
 * @param {string[]} subNavItemsToIgnore array of strings containing the subNav items we want to hide
 * @param {Navigation[]} subNav the navigation elements array
 */
var SubNavigation = function (props) {
    var subNavItemsToIgnore = props.subNavItemsToIgnore, subNav = props.subNav;
    return (react_1.default.createElement(material_1.Box, { display: { xs: 'none', md: 'block' } },
        react_1.default.createElement("nav", { className: "sub-navigation" },
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("ul", { className: "menu" }, subNav === null || subNav === void 0 ? void 0 : subNav.filter(function (navItem) { return !(subNavItemsToIgnore === null || subNavItemsToIgnore === void 0 ? void 0 : subNavItemsToIgnore.includes(navItem.displayValue)); }).map(function (nav) { return (react_1.default.createElement("li", { key: nav.key, className: "menu-item" },
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "subtitle1 mb-0", to: nav.route }, nav.displayValue))); }))))));
};
exports.default = SubNavigation;
// Note: SubNavigation does not have stories because there is nothing to render. It is only links.
